import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from "../../services/analytics.service";
import './form-item-home-services-vas.component.scss';
var FormItemHomeServicesVas = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemHomeServicesVas, _super);
    function FormItemHomeServicesVas(element) {
        return _super.call(this, element) || this;
    }
    FormItemHomeServicesVas.prototype.init = function () {
        this.applyForm = this.element.querySelector('form');
        this.successMessage = this.applyForm.querySelector(".form__success--container");
        this.errorMessage = this.applyForm.querySelector(".form__serror--container");
        this.applyFormSubmit = Array.from(this.element.querySelectorAll('.js-apply-now-hs-vas__button'));
        this.movingDate = Array.from(this.applyForm.querySelectorAll("input[name=movingDateKnown]"));
        this.preferedMovingDate = this.applyForm.querySelector("input[name=preferredMovingDate]");
    };
    FormItemHomeServicesVas.prototype.bindEvents = function () {
        var _this = this;
        this.applyFormSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            var formFields = _this.applyForm.querySelectorAll('input, select');
            var validation = _this.validationService.validate(formFields);
            var valid = Array.from(_this.applyForm.querySelectorAll(".form__group--error"));
            if (valid.length == 0) {
                _this.SubmitApplicationFormHomeServicesVas(_this.applyForm, _this.element.querySelector('.form__loader--container'), _this.element.querySelector('.form__thankyou--container'));
            }
        }); });
        if (this.movingDate) {
            this.movingDate.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    if (_this.preferedMovingDate) {
                        if (_radio.value == "NO") {
                            _this.preferedMovingDate.classList.remove("form__input--required");
                        }
                        else {
                            _this.preferedMovingDate.classList.add("form__input--required");
                        }
                    }
                });
            });
        }
        // Reset the form
        this.applyForm.addEventListener('custom_form_reset_event', function (e) {
            if (_this.errorMessage) {
                _this.errorMessage.classList.remove('active');
            }
            if (_this.successMessage) {
                _this.successMessage.classList.remove('active');
            }
        }, false);
    };
    FormItemHomeServicesVas.prototype.SubmitApplicationFormHomeServicesVas = function (form, loader, thankyou) {
        // additional containers
        var declined = form.querySelector('.form__declined--container');
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        var _actionName = form.querySelector("input[name=actionname]");
        // fields
        var _fields = {};
        for (var a = 0; a < form.length; a++) {
            var _field = form[a];
            _fields[_field.name] = _field.value;
        }
        _fields['reqVisitorId'] = this.analyticsService.getDtmVisitorID();
        var fields = 'actionname=' + _actionName.value + '&vasformJSONData=' + JSON.stringify(_fields);
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/homeservices/sbhsvasfoursure";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, fields, config).then(function (response) {
            var data = response.data;
            // service ok
            analyticsService.dtmFormComplete('complete', 'true');
            loader.classList.remove('active');
            analyticsService.dtmFormComplete('complete', '');
            loader.classList.remove('active');
            thankyou.classList.add('active');
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            fieldsContainer.classList.add('hidden');
            fieldsContainer.classList.remove('active');
            thankyou.classList.remove('active');
            thankyou.classList.add('hidden');
            error.classList.add('active');
            error.classList.remove('active');
        });
    };
    return FormItemHomeServicesVas;
}(Base));
export { FormItemHomeServicesVas };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-home-services-vas/form-item-home-services-vas.component.ts
// module id = 908
// module chunks = 0